import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { API_URL } from "../constant";

const Logout = () => {
  const [showModal, setShowModal] = useState(true);
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      console.log('Attempting logout...');
      const response = await axios.post(
        `${API_URL}/api/logout`,
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('authToken')}`,
          },
        }
      );

      console.log('Logout successful:', response.data);
      // Remove the auth token from localStorage after successful logout
      localStorage.removeItem('authToken');
      console.log('authToken removed from localStorage');

      setTimeout(() => {
        navigate('/');
      }, 1000);
    } catch (error) {
      console.error('Logout failed:', error.response?.data || error.message);
    } finally {
      setShowModal(false);
    }
  };

  const handleCancel = () => {
    setShowModal(false);
    navigate('/Dashboard');
  };

  return (
    <div>
      {/* Confirmation Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-gray-400 bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-md w-full max-w-sm text-center">
            <h3 className="text-xl font-semibold">Are you sure want to log out?</h3>
            <div className="mt-4 flex justify-around">
              <button
                onClick={handleLogout}
                className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
              >
                Yes, Log out
              </button>
              <button
                onClick={handleCancel}
                className="px-4 py-2 bg-gray-400 text-black rounded-md hover:bg-gray-500"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Logout;
